import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import modernVisual from "../assets/paying5.jpeg";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";
import { useState } from "react";

export default function About() {
  const { lang } = useLanguage();
  const t = translations[lang].about;

  return (
    <div className="overflow-x-hidden">

    
      {/* ---------------- ABOUT / QUOTE ---------------- */}
      <section className="bg-gray-50 py-28 text-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mx-auto space-y-6"
        >
          <h2 className="text-5xl md:text-6xl font-extrabold text-red-600 tracking-tight">
            {t.title}
          </h2>

          <p className="text-3xl md:text-4xl font-light italic text-gray-700 leading-snug">
            “{t.quote}”
          </p>

          <div className="text-lg md:text-xl uppercase tracking-wide text-red-400 font-semibold">
            {t.subtitle}
          </div>
        </motion.div>
      </section>

      {/* ---------------- IMAGE + TEXT ---------------- */}
      <section className="max-w-6xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">

        {/* VISUAL */}
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="rounded-2xl overflow-hidden shadow-xl hover:scale-105 transition-transform"
        >
          <img
            src={modernVisual}
            alt="HelvaticaAssist visual"
            className="w-full max-h-[500px] object-cover"
          />
        </motion.div>

        {/* TEXT */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="space-y-8"
        >
          <p className="text-gray-700 leading-relaxed text-lg">
            <strong>HelvetAssist</strong> {t.intro1}
          </p>

          <p className="text-gray-700 leading-relaxed text-lg">
            {t.intro2}
          </p>

          {/* VALUES */}
          <div className="grid sm:grid-cols-3 gap-6 pt-6">
            <div className="border-l-2 border-red-600 pl-5">
              <div className="text-sm uppercase tracking-wide text-gray-500 mb-2">
                {t.missionTitle}
              </div>
              <div className="font-semibold text-lg">
                {t.missionText}
              </div>
            </div>

            <div className="border-l-2 border-red-600 pl-5">
              <div className="text-sm uppercase tracking-wide text-gray-500 mb-2">
                {t.valuesTitle}
              </div>
              <div className="font-semibold text-lg">
                {t.valuesText}
              </div>
            </div>

            <div className="border-l-2 border-red-600 pl-5">
              <div className="text-sm uppercase tracking-wide text-gray-500 mb-2">
                {t.approachTitle}
              </div>
              <div className="font-semibold text-lg">
                {t.approachText}
              </div>
            </div>
          </div>
        </motion.div>
      </section>

      {/* ---------------- WHAT WE DO ---------------- */}
      <section className="max-w-6xl mx-auto px-6 py-24">
        <h3 className="text-3xl font-bold text-red-600 mb-12 text-center">
          {t.whatWeDo}
        </h3>

        <div className="grid md:grid-cols-2 gap-10">
          {t.services.map((item, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition"
            >
              <h4 className="font-semibold text-xl text-red-600 mb-3">
                {item.title}
              </h4>
              <p className="text-gray-700">
                {item.text}
              </p>
            </div>
          ))}
        </div>

        {/* ---------------- CTA ---------------- */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mt-24 text-center bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl py-20 px-6"
        >
          <h4 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            {t.ctaTitle}
          </h4>

          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-10">
            {t.ctaText}
          </p>

          <Link
            to="/services"
            className="inline-flex items-center gap-3 text-red-600 font-semibold text-xl hover:text-red-700 transition group"
          >
            {t.ctaLink}
            <span className="group-hover:translate-x-1 transition-transform">
              →
            </span>
          </Link>
        </motion.div>
      </section>
    </div>
  );
}